import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagEditarVentasFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagAkdemic'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagAkdemic'
          label='Usuario Akdemic'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagEditarVentasFormGroup)
